import React, { Suspense, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import { Panel, Button } from 'react-bootstrap';
import withAuthentication from '../../hoc/withAuthentication';
import withLayout from '../../hoc/withLayout';

import { useAlertStore } from '../../store/providers/Alert';
import { useMembersStore } from '../../store/providers/Members';
import Permission from '../../components/Permission/Permission';
import { breadcrumbAddRoute, breadcrumbRemoveRoute } from '../../store/actions/breadcrumb';
import Spinner from '../../components/Spinner/Spinner';
import { navigate } from 'raviger';

import * as constants from '../../constants';
import { columns, sorting } from './MembersListSchema';
import DocumentSetupList from '../../components/Lists/DocumentSetupList/DocumentSetupList';
const SideMenu = React.lazy(() => import('../../components/SideMenu/SideMenu'));
const PageHeader = React.lazy(() => import('../../components/PageHeader/PageHeader'));
const MemberModal = React.lazy(() => import('../../components/Modals/MemberModal/MemberModal'));


function Members(props) {
    const dispatch = useDispatch();
    const { addAlert } = useAlertStore();
    const { listRecords, selectRecord, newRecord, deleteRecord, data, clearData } = useMembersStore();

    const [isMounted, setIsMounted] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [listData, setListData] = useState([]);
    const [pageTitle, setPageTitle] = useState("");

    const pagePermission = constants.PERMISSION_FRANCHISES;
    const [hasPermission, setHasPermission] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    const selectedHandler = (member) => {
        setIsEditing(true);
        selectRecord({ memberId: member.id });
    };

    const addedHandler = () => {
        setIsEditing(true);
        newRecord();
    };

    const cancelledHandler = () => {
        setIsEditing(false);
    };

    const handleClickBackToList = () => {
        navigate(`/gmailGroups`);
    }

    const submittedHandler = () => {
        setIsEditing(false);
        listRecords({ groupId: props.groupId });
    };

    const deletedHandler = (member) => {
        deleteRecord({ memberId: member.id });
    };

    const refreshedHandler = () => {
        listRecords({ groupId: props.groupId });
    };

    useEffect(() => {
        if (!_.isEmpty(data)) {

            if (data.status === 'fail' || data.status === 'error') {
                addAlert({ key: constants.ALERT_SERVER_ERROR, text: <strong>{data.body}</strong>, type: constants.ALERT_TYPE_DANGER });
                clearData();
            }

            if (data.scope === 'delete' && data.status === 'success') {
                listRecords({ groupId: props.groupId });
            }

            if (data.status === 'success' && data.scope === 'list') {
                setPageTitle(data.body.gmailGroupName + " - " + data.body.gmailGroupEmail);
                setListData(data.body.members);
            }

            setIsBusy(data.status === 'processing' && (data.scope === 'delete' || data.scope === 'list'));
        }
    }, [data, addAlert, clearData, listRecords]);


    useEffect(() => {
        if (!hasPermission) { return; }
        if (isMounted) { return; }

        dispatch(breadcrumbAddRoute({ key: 'gmailGroups', parent: 'Settings', text: 'Gmail Groups', path: '/gmailGroups' }));
        dispatch(breadcrumbAddRoute({key: 'members', text: 'Members', path: '/members'}));

        if (!_.isEmpty(props.groupId)) {
            listRecords({ groupId: props.groupId });
        }

        setIsMounted(true);
    }, [isMounted, hasPermission, listRecords, dispatch]);

    useEffect(() => {
        return () => {
            dispatch(breadcrumbRemoveRoute());
        };
    }, [dispatch]);

    return (
        <>
            <SideMenu activeKey="settings" />
            <div className="content-body">
                <Permission showDenied={true} pagePermission={pagePermission} hasPermission={hasPermission} setHasPermission={setHasPermission} setCanEdit={setCanEdit} />
                {hasPermission && isMounted &&
                    <Suspense fallback={<Spinner text="Loading..." />}>
                        {
                            isEditing && <MemberModal
                                show={isEditing}
                                canEdit={canEdit}
                                title={(!_.isEmpty(data) && !_.isEmpty(data.body)) ? 'Edit User' : 'Add User'}
                                groupId={props.groupId}
                                cancelled={() => cancelledHandler()}
                                submitted={() => submittedHandler()} />
                        }
                        <div style={{ paddingRight: '15px' }}>
                            <PageHeader title={pageTitle} />
                            <Panel>
                                <Panel.Body>
                                    <DocumentSetupList
                                        compType="User"
                                        listData={listData}
                                        isBusy={isBusy}
                                        sorting={sorting}
                                        columns={columns}
                                        hideCopy={true}
                                        hidePrint={true}
                                        hideFilter={true}
                                        permissionEdit={canEdit}
                                        added={() => addedHandler()}
                                        selected={(member) => selectedHandler(member)}
                                        deleted={(member) => deletedHandler(member)}
                                        refreshed={() => refreshedHandler()} />
                                        <hr className="form-divider" />
                                        <div className="form-action-buttons">
                                            <Button bsStyle="default" onClick={() => handleClickBackToList()} className="button-group-margin" disabled={isBusy}>
                                                <i className="fa fa-undo button-icon"></i>
                                                Back to List
                                            </Button>
                                        </div>
                                </Panel.Body>
                            </Panel>
                        </div>
                    </Suspense>
                }
            </div>
        </>
    );
}
export default withAuthentication(withLayout(Members));





